import {
  MenuList as ChakraMenuList,
  MenuListProps as ChakraMenuListProps,
  forwardRef,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type MenuListProps = SwashbuckleComponentProps<ChakraMenuListProps>

// Needs box shadow: -3px 3px 6px 1px rgba(0,0,0,.3)

export const MenuList = forwardRef<MenuListProps, 'div'>((props, ref) => {
  const { 'data-qa': dataQa, className, ...chakraMenuListProps } = props

  return (
    <ChakraMenuList
      ref={ref}
      data-qa={dataQa}
      className={className}
      {...chakraMenuListProps}
    />
  )
})

MenuList.displayName = 'MenuList'
